module.exports = __webpack_public_path__ + "static/media/paprika-merah.48ef4738.jpeg";